import type { VoiceUserState } from '@/types/api';

/**
 * Whether a person's microphone shows as off. Sound off stops transmitting
 * too (voiceMedia.applyTransmit), so a deafened person reads as muted
 * everywhere — their own buttons, the channel list, the voice tiles — even
 * though their own mic toggle keeps its separate value.
 */
export function micShownOff(
  state: Pick<VoiceUserState, 'selfMute' | 'serverMute' | 'selfDeaf' | 'serverDeaf'>,
): boolean {
  return state.selfMute || state.serverMute || state.selfDeaf || state.serverDeaf;
}
